import { configureStore } from "@reduxjs/toolkit";
import auth from "./authenticationSlice";
import notificationSlice from "./notificationSlice";


export const store = configureStore({
  reducer: {
    auth,
    notificationSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;
